import { render, staticRenderFns } from "./ContactWay.vue?vue&type=template&id=07735900&scoped=true"
import script from "./ContactWay.vue?vue&type=script&lang=ts"
export * from "./ContactWay.vue?vue&type=script&lang=ts"
import style0 from "./ContactWay.vue?vue&type=style&index=0&id=07735900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07735900",
  null
  
)

export default component.exports